import React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: 'Active' | 'Scheduled' | 'Draft' | 'Ready' | 'Rendering' | string;
  variant?: 'primary' | 'secondary' | 'outline';
}

export function Badge({ status, variant, className = '', children, ...props }: BadgeProps) {
  const content = children || status;

  let styles =
    'px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider inline-flex items-center justify-center';

  // Specific status overrides
  if (status) {
    switch (status) {
      case 'Active':
        styles += ' bg-primary/10 text-primary';
        break;
      case 'Scheduled':
        styles += ' bg-tertiary/10 text-tertiary';
        break;
      case 'Draft':
        styles += ' bg-stone-100 text-on-surface-variant';
        break;
      case 'Ready':
        styles += ' bg-white text-tertiary border border-outline-variant/30';
        break;
      case 'Rendering':
        styles += ' bg-primary-container text-primary border border-primary-fixed';
        break;
      default:
        styles += ' bg-surface-container-high text-on-surface';
    }
  } else if (variant) {
    if (variant === 'primary') styles += ' bg-primary/10 text-primary';
    if (variant === 'secondary') styles += ' bg-secondary-container text-on-secondary-container';
    if (variant === 'outline')
      styles += ' bg-white border border-outline-variant/30 text-on-surface-variant';
  }

  return (
    <span className={`${styles} ${className}`} {...props}>
      {content}
    </span>
  );
}
